import { render } from "./ProfileLayoutCompact.vue?vue&type=template&id=083468a6&scoped=true"
import script from "./ProfileLayoutCompact.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutCompact.vue?vue&type=script&lang=js"

import "./ProfileLayoutCompact.vue?vue&type=style&index=0&id=083468a6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083468a6"]])

export default __exports__